import React, { memo } from 'react';

import barnOwlClient, { AttachBarnOwlCameraDto } from 'clients/barnOwl';
import BackOfficeBarnOwlFormDrawer from 'components/drawers/BackOfficeBarnOwlFormDrawer';
import BarnOwlAttachFormItems from 'components/forms/BarnOwlAttachFormItems';
import { SEARCH_PARAMS } from 'constants/search-params';

type BarnOwlAttachFormValues = AttachBarnOwlCameraDto & {
  enterpriseId: number;
};

function BackOfficeBarnOwlAttachDrawer(): JSX.Element {
  return (
    <BackOfficeBarnOwlFormDrawer<BarnOwlAttachFormValues>
      drawerValue={SEARCH_PARAMS.DRAWER.values.ATTACH_BARN_OWL_CAMERA}
      title="Attach Barn Owl camera"
      footerLabel="Attach camera"
      submit={async ({ enterpriseId, cameraName, IMEI, ICCID, siteId }) => {
        const response = await barnOwlClient.attachBarnOwlCamera(Number(enterpriseId), {
          cameraName,
          IMEI,
          ICCID,
          siteId
        });
        if (response.error) {
          return { error: response.error.message || 'Unable to attach Barn Owl camera' };
        }
        return {
          successMessage: `Attached Barn Owl camera ${response.data?.cameraName ?? cameraName}`
        };
      }}
    >
      <BarnOwlAttachFormItems />
    </BackOfficeBarnOwlFormDrawer>
  );
}

export default memo(BackOfficeBarnOwlAttachDrawer);
